import React from "react";
import styles from "./PageContainer.module.scss";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import isOnPage, {
  MESSAGES_PAGE,
  ORDERS_PAGE,
  PRODUCT_DETAILS_PAGE,
} from "@src/utils/isOnPage";

interface PageContainerProps {
  children?: React.ReactNode;
}

export default function PageContainer({ children }: PageContainerProps) {
  const location = useLocation();
  const shouldFixMainContentHeight =
    isOnPage(MESSAGES_PAGE, location.pathname) ||
    isOnPage(ORDERS_PAGE, location.pathname);
  const shouldUseWhiteBackground = isOnPage(
    PRODUCT_DETAILS_PAGE,
    location.pathname,
  );

  return (
    <div
      className={classnames(styles.root, {
        [styles.fixMainContentHeight]: shouldFixMainContentHeight,
        [styles.whiteBackground]: shouldUseWhiteBackground,
      })}
    >
      {children}
    </div>
  );
}
